/**
 * Uproszczony model wizyty (DTO) wykorzystywany do sprawdzania podstawowych informacji
 * o wizytach użytkowników aplikacji mobilnej (np. w akcji "Sprawdź wizyty").
 * Zaprojektowany z myślą o maksymalnej wydajności – pobiera tylko podstawowe
 * metadane i flagi statusów, pomijając cięższe powiązania.
 */
export class SimpleCheckVisit {

  /** Data i czas odbycia się wizyty. */
  public wizDate: Date;

  /** Data zaplanowanej (lub wykonanej) synchronizacji.
   */
  public scheduledSync: Date;

  /** Vetcode konkretnej placówki, w której była wizyta. */
  public vetcodeId: number;

  /** Nazwa pacjenta (zwierzęcia), którego dotyczyła wizyta. */
  public animalName: string;

  /** Flaga informująca, czy do tej wizyty dołączone są wyniki badań laboratoryjnych.
   */
  public hasLabTestData: boolean;

  /** Flaga informująca, czy lekarz wystawił po tej wizycie dodatkowe zalecenia
   */
  public hasRecommendations: boolean;

  /** Nazwa kliniki.
   */
  public clinicName: string;

}
